import { Fragment } from 'react'
import type { CartLine } from '@/lib/cart'

// Display tidy-ups for the bundle spec list. Slot labels come from the DB; a
// couple read long on a narrow cart line, so shorten the known ones (raw label
// otherwise). And values sometimes repeat the slot name (slot "Boardbag",
// option "Boardbag (Size S)") — strip that prefix so the value reads "Size S".
const SHORT_KIT_LABELS: Record<string, string> = {
  'Hydrofoil Unit Kit': 'Hydrofoil',
}
function shortKitLabel(label: string): string {
  return SHORT_KIT_LABELS[label] ?? label
}
function cleanKitValue(label: string, value: string): string {
  const v = value.trim()
  if (v.toLowerCase().startsWith(label.toLowerCase())) {
    const stripped = v.slice(label.length).trim().replace(/^\((.*)\)$/, '$1').trim()
    if (stripped) return stripped
  }
  return v
}

/**
 * A configured kit's slots as a two-column spec list (Board → Black Carbon),
 * shared by the cart drawer and the checkout summary so a kit reads the same
 * in both. Values wrap rather than truncate: the choices ARE the purchase.
 * Falls back to the joined `bundleDescription` for carts persisted before
 * `bundleOptions` existed.
 */
export default function BundleSpecList({ item }: { item: Pick<CartLine, 'bundleOptions' | 'bundleDescription'> }) {
  if (item.bundleOptions?.length) {
    return (
      <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">
        {item.bundleOptions.map((opt) => (
          <Fragment key={opt.label}>
            <dt className="whitespace-nowrap text-xs text-[var(--color-text-muted)]">{shortKitLabel(opt.label)}</dt>
            <dd className="m-0 min-w-0 break-words text-xs font-medium text-[var(--color-text-secondary)]">{cleanKitValue(opt.label, opt.value)}</dd>
          </Fragment>
        ))}
      </dl>
    )
  }
  return item.bundleDescription ? <p className="mt-0.5 text-xs text-[var(--color-text-muted)]">{item.bundleDescription}</p> : null
}
